"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = { name: "@video/video-client-core", version: "13.2.0", commit: "79ee25b1fd57cc49823e11b1b9305f4cd0df057c" };
//# sourceMappingURL=package-json.js.map